module.exports = __webpack_public_path__ + "static/media/7.1d6cf9ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/andimar/fleet/7.jpg
// module id = 1188
// module chunks = 0